import { render } from "./Free.vue?vue&type=template&id=7bc40efc"
import script from "./Free.vue?vue&type=script&lang=js"
export * from "./Free.vue?vue&type=script&lang=js"
script.render = render

export default script